import { Component, Input } from '@angular/core';
import { InfoItem } from '@frk/eds-components';
import { TranslateService } from '@shared/translate/translate.service';
import { DistributionSchedules } from '@types';

@Component({
  selector: 'ft-distribution-schedules',
  templateUrl: './distribution-schedules.component.html',
  styleUrls: ['./distribution-schedules.component.scss'],
})
export class DistributionSchedulesComponent {
  @Input() schedules: DistributionSchedules;

  constructor(private translateService: TranslateService) {}

  /**
   * Fetch info item object for schedule types.
   * @param schedule dividend/capgains
   */
  getInfoItemData(schedule: string): InfoItem {
    return schedule === 'dividend'
      ? {
          label: this.translateService.instant('pds.DIVIDEND_DISTRIBUTIONS'),
          val: this.schedules?.dividendFrequency,
          labelSmallText:
            this.schedules?.distributionIndicator.toLowerCase() === 'acc'
              ? this.translateService.instant(
                  'products.distribution-schedules-explanatory-accrual'
                )
              : this.translateService.instant(
                  'products.distribution-schedules-explanatory-ex-dividend'
                ),
          tooltip: this.translateService.instant(
            'products.distribution-schedules-exdiv-tooltip-content'
          ),
          tooltipName: this.translateService.instant(
            'pds.DIVIDEND_DISTRIBUTIONS'
          ),
          caveatPlacement: 'Distribution:SchedulesExDiv',
        }
      : {
          label: this.translateService.instant(
            'pds.CAPITAL_GAIN_DISTRIBUTIONS'
          ),
          val: this.schedules?.capgainFrequency,
          tooltip: this.translateService.tooltip(
            'products.distribution-schedules-capgain'
          ),
          tooltipName: this.translateService.instant(
            'pds.CAPITAL_GAIN_DISTRIBUTIONS'
          ),
          caveatPlacement: 'Distribution:SchedulesCapGain',
        };
  }
}
